import React from "react";
import api from "../../../api";

export function useGetAreas() {
    const [items, setItems] = React.useState([])
    const [pointOptions, setPointOptions] = React.useState([])

    React.useEffect(() => {
        getItems()
    }, [])

    async function getItems() {
        try {
            const { data } = await api.get(`delivery-zones?cityId=${1}`, {useV2Api: true})
            const options = [];
            data.items.forEach((point) => {
                const name = point.shortName.find((name) =>  name.language === "ru")?.content ?? "Точка"
                options.push(
                    {
                        label: name,
                        value: point.id
                    }
                )
            })
            setItems(data.items)
            setPointOptions(options)
        } catch (e) {
            console.warn("Ошибка загрузки")
        }

    }
    return {
        items,
        refetch: () => getItems(),
        options: { pointOptions }
    }
}
